import api from './client';

export const fetchPickupAddresses = () =>
  api.get('/pickup-addresses').then(r => r.data);

export const createPickupAddress = (data: any) =>
  api.post('/pickup-addresses', data).then(r => r.data);

export const updatePickupAddress = (id: number, data: any) =>
  api.put(`/pickup-addresses/${id}`, data).then(r => r.data);

export const deletePickupAddress = (id: number) =>
  api.delete(`/pickup-addresses/${id}`).then(r => r.data);

export const syncPickupAddressesFromShipStation = () =>
  api.post('/pickup-addresses/sync').then(r => r.data as {
    fetched: number;
    created: number;
    updated: number;
    skipped: number;
  });
